export const fontNames = {
  Roboto: 'Roboto',
  SF_UI_REGULAR: 'SF UI Display Regular',
  SF_UI_LIGHT: 'SF UI Display Light',
  SF_UI_BOLD: 'SF UI Display Bold',
  SF_COMPACT_TEXT_REGULAR: 'SF Compact Text Regular',
  APERCU_PRO_Regular: 'Apercu Pro',
  APERCU_PRO_MEDUIUM: 'Apercu Pro Medium',
  APERCU_PRO_BOLD: 'Apercu Pro Bold',
  TAJAWAL_BOLD: 'Tajawal Bold',
};

export const fontWieghts = {
  REGULAR: 400,
  MEDIUM: 500,
  BOLD: 700,
  LIGHT: 300,
};
